import axios from 'axios';
import { getStoredToken, isUserLoggedIn, clearAuthData,getOrgId } from '../utils/authUtils';
import { auth0Config } from '../config/auth0Config';
import axiosInstance from "./axiosInstance";
import { PayloadDetails } from '../components/Dashboard/PromoteModal';
import { apiConfig } from '../config/apiConfig';

// Get token from localStorage, fallback to hardcoded token for backwards compatibility
function getAuthToken(): string {
  const storedToken = getStoredToken();
  if (storedToken) {
    return storedToken.startsWith('Bearer ') ? storedToken : `Bearer ${storedToken}`;
  }
  
  // Log warning when using fallback token
  console.warn('No auth token found in localStorage, using fallback token for development');
  
  // Fallback to hardcoded token for development/testing
  return 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImJIZVBrYXN3NDlBU2YyeGtUTWxhdiJ9.eyJpc3MiOiJodHRwczovL2lkLnN0Zy5zeW5lcmdldGljcy5haS8iLCJzdWIiOiJlbWFpbHw2NWZhNzYyMjUxMzhlODhhZWMyNjMxNTEiLCJhdWQiOlsiaHR0cHM6Ly93ZWJ0aWdhLWd3LmNvbS9kYW0iLCJodHRwczovL3VuaWZ5Z3B0LWlhbS1zdGcudXMuYXV0aDAuY29tL3VzZXJpbmZvIl0sImlhdCI6MTc2Mjc2ODE1NiwiZXhwIjoxNzYyODU0NTU2LCJzY29wZSI6Im9wZW5pZCBwcm9maWxlIGVtYWlsIG9mZmxpbmVfYWNjZXNzIiwib3JnX2lkIjoib3JnX2ljMmxmUEMyNThsTXM1dTkiLCJhenAiOiJYM0hRYUtHWEpSU1RVSHdOdlJSMkdZZTJMRzllQm51cyIsInBlcm1pc3Npb25zIjpbXX0.gn1yVt_nTzd5ToBHlJP1i34_9c9ipLK96dh6_yjK0zFchZTD3rNa9SFqls-4Yi6PBjeRHn0to2RDm0QDzR_7XTvImM2vuL6yJERSG5_n0bvUNxqtEVWVNejDEKX8qu10nBmDNI_hTjtz82zjQcQRL6Jne8lWGDZPSWO0i2-2hSz_aCZVv5yYxEudZUBnR3dy3K6u1jTFiqB6JWzlq4qYdnu-bH5myp46QzC5dbJj8UgFsbUE70ZQKFlHS77baqLyeiIvg0nOpTWpl13_FaZfHhjRCHHOoZWqhQ4LEdwpiD8-sc8GqdcV8v8LKnaoJ6n0Ddo6tfbsBqMjBNE8Te3uHw';
}

export const AUTH_TOKEN = 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImJIZVBrYXN3NDlBU2YyeGtUTWxhdiJ9.eyJpc3MiOiJodHRwczovL2lkLnN0Zy5zeW5lcmdldGljcy5haS8iLCJzdWIiOiJlbWFpbHw2NWZhNzYyMjUxMzhlODhhZWMyNjMxNTEiLCJhdWQiOlsiaHR0cHM6Ly93ZWJ0aWdhLWd3LmNvbS9kYW0iLCJodHRwczovL3VuaWZ5Z3B0LWlhbS1zdGcudXMuYXV0aDAuY29tL3VzZXJpbmZvIl0sImlhdCI6MTc2Mjc2ODE1NiwiZXhwIjoxNzYyODU0NTU2LCJzY29wZSI6Im9wZW5pZCBwcm9maWxlIGVtYWlsIG9mZmxpbmVfYWNjZXNzIiwib3JnX2lkIjoib3JnX2ljMmxmUEMyNThsTXM1dTkiLCJhenAiOiJYM0hRYUtHWEpSU1RVSHdOdlJSMkdZZTJMRzllQm51cyIsInBlcm1pc3Npb25zIjpbXX0.gn1yVt_nTzd5ToBHlJP1i34_9c9ipLK96dh6_yjK0zFchZTD3rNa9SFqls-4Yi6PBjeRHn0to2RDm0QDzR_7XTvImM2vuL6yJERSG5_n0bvUNxqtEVWVNejDEKX8qu10nBmDNI_hTjtz82zjQcQRL6Jne8lWGDZPSWO0i2-2hSz_aCZVv5yYxEudZUBnR3dy3K6u1jTFiqB6JWzlq4qYdnu-bH5myp46QzC5dbJj8UgFsbUE70ZQKFlHS77baqLyeiIvg0nOpTWpl13_FaZfHhjRCHHOoZWqhQ4LEdwpiD8-sc8GqdcV8v8LKnaoJ6n0Ddo6tfbsBqMjBNE8Te3uHw';

type DamData = any;
type MarketplaceData = any;

export async function createDamAsset(damData: DamData) {
  try {
    const response = await axiosInstance.post(
      '/dam/api/v1/digital-assets',
      damData,
      // {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': getAuthToken(),
      //   },
      // }
    );
    return {
      statusCode: response.status,
      ...response.data,
    };
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        ...error.response.data,
      };
    }
    throw error;
  }
}

export async function createMarketplaceListing(listingData: MarketplaceData) {
  try {
    const response = await axiosInstance.post(
      '/marketplace/api/v1/assets',
      listingData,
      // {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': getAuthToken(),
      //   },
      // }
    );
    return {
      statusCode: response.status,
      ...response.data,
    };
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        ...error.response.data,
      };
    }
    throw error;
  }
}

export async function createBatchDamAssets(assetsData: DamData[]) {
  try {
    const response = await axiosInstance.post(
      '/dam/api/v1/digital-assets/batch',
      assetsData,
    );
    return {
      statusCode: response.status,
      data: response.data,
    };
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        ...(typeof error.response.data === 'object' ? error.response.data : { message: error.response.data }),
      };
    }
    throw error;
  }
}

export async function createWearableItem(wearableData: any) {
  try {
    const response = await axiosInstance.post(
      '/api-blockchain/v2/wearable/add-item',
      wearableData,
    );
    return {
      statusCode: response.status,
      ...response.data,
    };
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        ...error.response.data,
      };
    }
    throw error;
  }
}

export async function createSkillItem(skillData: any) {
  try {
    const response = await axiosInstance.post(
      '/api-blockchain/v2/marketplaceNFT/skill/add-item',
      skillData,
    );
    return {
      statusCode: response.status,
      ...response.data,
    };
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        ...error.response.data,
      };
    }
    throw error;
  }
}

export async function createWorkflowItem(workflowData: any) {
  try {
    const response = await axiosInstance.post(
      '/api-blockchain/v2/marketplaceNFT/workflow/add-item',
      workflowData,
    );
    return {
      statusCode: response.status,
      ...response.data,
    };
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        ...error.response.data,
      };
    }
    throw error;
  }
}

export async function parseWearableFile(file: File) {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosInstance.post(
      '/api-blockchain/v2/wearable/parse-file',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return {
      statusCode: response.status,
      ...response.data,
    }
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        ...error.response.data,
      };
    }
    throw error;
  }
}


export interface Currency {
  _id: string;
  code: string;
  name: string;
  type: string;
  __v: number;
}

export async function getCurrencies(): Promise<{
  statusCode: number;
  data: Currency[];
}> {
  try {
    const response = await axiosInstance.get(
      '/marketplace/api/v1/currencies',
    );
    return {
      statusCode: response.status,
      data: response.data || [],
    };
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        ...error.response.data,
        data: [],
      };
    }
    throw error;
  }
}

export interface PurchaseTypeOption {
  _id: string;
  purchaseType: string;
  allowMultiple: boolean;
}

export interface AssetPurchaseType {
  _id: string;
  assetType: string;
  purchaseTypes: PurchaseTypeOption[];
  __v: number;
}

export async function getAssetPurchaseTypes(): Promise<{
  statusCode: number;
  data: AssetPurchaseType[];
}> {
  try {
    const response = await axiosInstance.get(
      '/marketplace/api/v1/asset-types',
    );
    return {
      statusCode: response.status,
      data: response.data || [],
    };
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        data: [],
      };
    }
    throw error;
  }
}

export async function getDigitalAssetTypes(itemType?: string) {
  // console.log('Fetching digital asset types with itemType:', itemType);
  try {
    // Map item types to their corresponding digital asset type names for filtering
    const itemTypeFilterMap: { [key: string]: string } = {
      agent: 'Agent',
      avatar: 'Avatar',
      skill: 'Skill',
      model: 'Model',
      data: 'Brain',
      wearables: 'Wearable',
      workflow: 'Workflow',
    };

    // Get the filter name based on itemType, default to Agent if not provided
    const filterName = itemType ? itemTypeFilterMap[itemType] : 'Agent';
    
    const filter = {
      where: [
        { name: filterName }
      ]
    };
    
    const response = await axiosInstance.get(
      `/dam/api/v1/digital-asset-types?filter=${JSON.stringify(filter)}`
    );
    console.log('Received digital asset types response:', response.data);
    return {
      statusCode: response.status,
      data: response.data[0]?.id || "",
    };
  } catch (error: any) {
    if (error.response) {
      return {
        statusCode: error.response.status,
        data: [],
      };
    }
    throw error;
  }
}
export async function updateAsset(assetId: MarketplaceData,data:any) {
  try {
    const baseUrl = process.env.REACT_APP_MARKETPLACE_API_URL
    const response = await axios.put(
      `${baseUrl}/assets/${assetId}`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getAuthToken(),
        },
      }
    );
    return response
  } catch (error: any) {
    console.log("publish error", error)
    throw error;
  }
}
export async function publishAsset(assetId: MarketplaceData) {
  try {
    const baseUrl = process.env.REACT_APP_MARKETPLACE_API_URL
    const response = await axios.put(
      `${baseUrl}/assets/${assetId}/publish`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getAuthToken(),
        },
      }
    );
    return response
  } catch (error: any) {
    console.log("publish error", error)
    throw error;
  }
}
export async function getMarketplaceList() {
  try {
    const baseUrl = process.env.REACT_APP_MARKETPLACE_API_URL
    const response = await axios.get(`${baseUrl}/assets?sort=createdAt&sortDirection=desc&limit=10&offset=0`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: getAuthToken()
      }
    })
    return response
  } catch (error: any) {
    console.log("publish error", error)
    throw error;
  }
}


export const getDigitalAssets = async (params: {
  orgId: string
  page: number;
  pageSize: number;
  search?: string;
}) => {
  const { page, pageSize, orgId, search = "" } = params;

  const filter = {
    id: "",
    skip: (page - 1) * pageSize, 
    take: pageSize,
    order: { createdAt: "DESC" },
    search,
    organizationId: orgId,
    digitalAssetTypeId: "",
    where: {},
  };

  try {
    const response = await axiosInstance.get(
      `/dam/api/v1/digital-assets?filter=${encodeURIComponent(
        JSON.stringify(filter)
      )}`,
      // {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: getAuthToken(),
      //   },
      // }
    );

    return {
      data: response.data || [],
      total: Number(response.headers["x-total-count"]) || 0,
      error: null,
    };
  } catch (error) {
    return {
      data: [],
      total: 0,
      error,
    };
  }
};

export async function getAgentSellerVerificationStatus() {
  console.log("Checking agent seller verification status")
  if (!isUserLoggedIn()) {
    throw new Error('User not logged in');
  }
  try {
    const response = await axios.get(
      `${apiConfig.agentseller.baseUrl}/agentseller/verification/status`,
      {
        headers: {
          'Authorization': getAuthToken(),
          'accept': 'application/json',
        },
      }
    );
    return response;
  } catch (error: any) {
    console.error('Error fetching agent seller verification status:', error);
    
    // Handle 403 Forbidden error
    if (error.response?.status === 403) {
      // Clear auth data from localStorage
      clearAuthData();
      
      // Redirect to Auth0 login page
      const logoutUrl = `https://${auth0Config.domain}/v2/logout?client_id=${auth0Config.clientId}&returnTo=${window.location.origin}`;
      window.location.href = logoutUrl;
      
      return;
    }
    
    throw error;
  }
}

export async function getCreditBalance() {
  const orgId = getOrgId();

  try {
    if (!orgId) {
      throw new Error("Org ID not found");
    }
    const baseUrl = process.env.REACT_APP_CREDITSERVICE_API_URL
    const response = await axios.get(
      `${baseUrl}/credits/organizations/${orgId}`,{
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
    }
    );
    return response.data;
  } catch (error: any) {
    console.log("Failed to get credit balance", error);
    throw error
  }
}

export async function createPromoteData(promoteData: PayloadDetails) {
  try {
    const response = await axiosInstance.post(
      '/marketplace/api/v1/promotions',
      promoteData,
    );
    return {
      statusCode: response.status,
      ...response.data,
    };
  } catch (error: any) {
    if (error.response) {
      throw {
        statusCode: error.response.status,
        message: error.response.data?.message
      };
    }
    throw error;
  }
}

export async function getOrgData() {
  
  try {
    const baseUrl = process.env.REACT_APP_MARKETPLACE_API_URL
    const response = await axios.get(
      `${baseUrl}/promotions/org`,{
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
    }
    );
    return response.data;
  } catch (error: any) {
    throw error
  }
}

export default {
  createDamAsset,
  createMarketplaceListing,
};
